import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { ProfileService } from '../../features/profile/services/profile.service';

@Injectable({ providedIn: 'root' })
export class ProfileGuard implements CanActivate {
  constructor(
    private profileService: ProfileService,
    private router: Router,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> {
    return this.profileService.getMyProfile().pipe(
      take(1),
      map((profile) => {
        return !profile.hasApprovalRequired
          ? true
          : this.router.createUrlTree(['/profile/edit']);
      }),
    );
  }
}
